import React from 'react';
import {graphql, useStaticQuery,} from 'gatsby'

//@ts-ignore
import styles from './footer.module.css'

const useLogoQuery = () => {
    const data = useStaticQuery(graphql`
        query Logo {
            contentfulAsset(file: {fileName: {eq: "sblogo.png"}}) {
                title
                file {
                    url
                    fileName
                    details {
                        size
                        image {
                            width
                            height
                        }
                    }
                }
            }
            allContentfulLink(filter: {buttonText: {in: ["twitter", "facebook", "instagram", "LinkedIn", "emailMailTo", "youtube"]}}) {
                nodes {
                        buttonText
                  url
                }
            }
        }
    `);
    const logoUrl = data?.contentfulAsset?.file?.url;
    const socialsData = data?.allContentfulLink?.nodes;
    return {logoUrl, socialsData}
}


export const Footer: React.FunctionComponent = (props) => {
    const {logoUrl, socialsData} = useLogoQuery();
    return(
        <div className={styles.footerContainer}>
            <div className={styles.footerContent}>

            <div className={styles.footerLogo}>
                <img src={logoUrl}/>
            </div>
            <div className={styles.socialsLogo}>
                {
                    socialsData.map(social => {
                        return (
                            <a href={social.url} target="_blank" rel="noopener noreferrer">
                                {   social.buttonText === "emailMailTo" ?
                                    <i className="fa fa-envelope"></i>
                                    :
                                    <i className={`fa fa-${social.buttonText.toLowerCase()}`} aria-hidden="true"></i>

                                }
                            </a>
                        )
                    })
                }
            </div>
            <p className={styles.copyright}>Copyright © 2021 Salesbeat. All rights reserved.</p>
            </div>
        </div>
    )
}